export default "__VITE_ASSET__CUbdR4iI__"